const VR = {

    init() {
        this.el = $('[url="virtualne-prehliadky"]');
        if (!this.el.length) return;

        this.button = this.el.find(".vr button.start");
        this.popupVR = $('[component="Popup"][name="vr"]');

        this.bind();
    },

    bind() {
        this.button.click((evt) => {
            this.popupVR.find("iframe").attr("src", $(evt.currentTarget).data("src"));
            return false;
        })
    },

    scrollToGallery() {
    }
}

export default VR;